module.exports = __webpack_public_path__ + "static/media/DqEveryChildNationThailandHero.95eaf921.jpg";